import React from 'react'
import Layout from '../../components/dashboard/Layout'

const Home = () => {
    return (
        <Layout>
            <div>Beranda</div>
            <div className="my-3">
                <img src="https://i.ibb.co/b6FkPKN/images-35.webp" className="w-100 img-fluid rounded" alt="Banner" />

            </div>
        </Layout>
    )
}

export default Home